<div class="date-range-picker">
  <button
    class="custom-select-button app-input"
    (click)="togglePanel($event)"
    aria-haspopup="dialog"
    aria-expanded="{{ showPanel }}"
  >
    <fa-icon [icon]="faCalendar" class="select-left-icon"></fa-icon>
    <span class="custom-select-label">
      {{ startDate ? (startDate | date: 'mediumDate') : placeholder }}
      @if (endDate) {
        <span class="date-pill__sep">–</span> {{ endDate | date: 'mediumDate' }}
      }
    </span>
  </button>

  <input #flatpickrInput type="text" class="hidden" />

  @if (showPanel) {
    <div class="panel">
      <div class="panel__header">
        <div class="panel__title">{{ panelTitle }}</div>
        <button
          class="panel__close"
          type="button"
          (click)="togglePanel($event)"
          aria-label="Cerrar"
        >
          ✕
        </button>
      </div>

      <div class="panel__body">
        <div class="panel-row">
          <label class="panel-label" [attr.for]="idPrefix + '-start'">Desde</label>
          <div class="panel-field">
            <input
              [id]="idPrefix + '-start'"
              type="date"
              class="app-input"
              style="padding-left: 0.75rem"
              [(ngModel)]="startDate"
              (blur)="onStartBlur()"
              [min]="minDate"
              [max]="maxDate"
            />
          </div>
        </div>

        <div class="panel-row">
          <label class="panel-label" [attr.for]="idPrefix + '-end'">Hasta</label>
          <div class="panel-field">
            <input
              [id]="idPrefix + '-end'"
              type="date"
              class="app-input"
              style="padding-left: 0.75rem"
              [(ngModel)]="endDate"
              (blur)="onEndBlur()"
              [min]="minDate"
              [max]="maxDate"
            />
          </div>
        </div>
      </div>

      <div class="panel__footer">
        <button class="app-btn app-btn--ghost" type="button" (click)="clear()">Limpiar</button>
        <div class="panel__footer-right">
          <button class="app-btn app-btn--secondary" type="button" (click)="togglePanel($event)">
            Cerrar
          </button>
          <button class="app-btn app-btn--primary" type="button" (click)="applyNative()">
            Aplicar
          </button>
        </div>
      </div>
    </div>
  }
</div>
